import React from 'react';
import { CheckCircle } from 'lucide-react';

const Integrations = () => {
  const integrations = [
    {
      name: 'AppsFlyer',
      logo: 'https://www.appsflyer.com/wp-content/uploads/2021/08/AF-Logo-Horizontal-Blue-1.svg',
      category: 'Attribution',
    },
    {
      name: 'Adjust',
      logo: 'https://www.adjust.com/wp-content/themes/adjust/dist/images/logo-adjust.svg',
      category: 'Analytics',
    },
    {
      name: 'Kochava',
      logo: 'https://www.kochava.com/wp-content/themes/kochava/assets/img/kochava-logo.svg',
      category: 'Attribution',
    },
    {
      name: 'Branch',
      logo: 'https://branch.io/wp-content/themes/branch/img/logo-branch.svg',
      category: 'Deep Linking',
    },
    {
      name: 'Singular',
      logo: 'https://www.singular.net/wp-content/themes/singular-2023/img/logo.svg',
      category: 'Marketing Analytics',
    },
    {
      name: 'Appmetrica',
      logo: 'https://avatars.githubusercontent.com/u/14203888?s=200&v=4',
      category: 'Analytics',
    },
  ];

  return (
    <section className="py-24 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-20">
          <div className="inline-flex items-center space-x-2 bg-cyan-500/10 border border-cyan-500/20 rounded-full px-4 py-2 backdrop-blur-sm mb-6">
            <CheckCircle className="w-4 h-4 text-cyan-400" />
            <span className="text-sm text-cyan-400 font-medium">Technology Partners</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-6">
            Seamlessly Integrated
            <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-blue-500">
              With Leading Platforms
            </span>
          </h2>
          <p className="text-xl text-slate-400 leading-relaxed">
            We work with industry-leading attribution and analytics platforms to provide comprehensive tracking and insights.
          </p>
        </div>

        {/* Integrations Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6 mb-16">
          {integrations.map((integration, index) => (
            <div
              key={index}
              className="group relative bg-slate-900/40 backdrop-blur-xl border border-slate-800/50 rounded-2xl p-8 hover:border-cyan-500/50 transition-all duration-300 flex flex-col items-center justify-center text-center"
            >
              {/* Logo Container */}
              <div className="w-full h-16 flex items-center justify-center mb-4">
                <img
                  src={integration.logo}
                  alt={integration.name}
                  className="max-w-full max-h-full object-contain filter brightness-0 invert opacity-70 group-hover:opacity-100 transition-opacity duration-300"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <div 
                  className="hidden text-2xl font-bold text-white"
                  style={{ display: 'none' }}
                >
                  {integration.name}
                </div>
              </div>

              {/* Name and Category */}
              <div className="space-y-1">
                <h3 className="text-sm font-semibold text-white">{integration.name}</h3>
                <p className="text-xs text-slate-400">{integration.category}</p>
              </div>

              {/* Hover Effect */}
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-cyan-500/5 to-blue-500/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center">
          <p className="text-slate-400 text-lg mb-6">
            Plus integrations with all major ad networks and marketing platforms
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {['Google Ads', 'Facebook Ads', 'TikTok', 'Snapchat', 'Twitter', 'Unity Ads'].map((platform, idx) => (
              <span
                key={idx}
                className="inline-block bg-slate-800/50 border border-slate-700 rounded-full px-4 py-2 text-sm text-slate-300"
              >
                {platform}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Integrations;
